<app-dynamic-grid
  [internalId]="DynamicContentfulGrid.checkout_login_bottom_grid"
></app-dynamic-grid>
